import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { SettingsToSaveType } from "./settings-to-save.type";

@Injectable({ providedIn: "root" })
export class TemplateSettingsService {
  constructor(private httpClient: HttpClient) {}

  saveCommunicationSettings(userId: number, settings: SettingsToSaveType) {
    return this.httpClient.post<any>(
      `/servlets/accounts/users/${userId}/communication/settings/`,
      settings
    );
  }
}
